import { useState, useEffect } from 'react';

const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=[]{}|;:",.<>/?';

const scrambleText = (text, iterations, onUpdate, onComplete) => {
  let originalText = text;
  let iteration = 0;
  
  const interval = setInterval(() => {
    let newText = '';
    for (let i = 0; i < originalText.length; i++) {
      let isSettled = i < iteration;
      newText += isSettled ? originalText[i] : characters[Math.floor(Math.random() * characters.length)];
    }
    
    onUpdate(newText);
    
    if (iteration > originalText.length + 10) {
      clearInterval(interval);
      onComplete(originalText);
    }
    
    iteration++;
  }, 30);
};

export function useScrambleText(text, play) {
  const [displayText, setDisplayText] = useState('');
  const [isFinished, setIsFinished] = useState(false); // New state to track completion

  useEffect(() => {
    if (play) {
      setIsFinished(false);
      scrambleText(
        text, 
        10, 
        (newText) => setDisplayText(newText),
        (finalText) => {
          setDisplayText(finalText);
          setIsFinished(true); // Set to true when the animation is done
        }
      );
    } else {
      setDisplayText(text);
      setIsFinished(true);
    }
  }, [play, text]);

  // Return both the animated text and the completion status
  return [displayText, isFinished]; 
}